<template>
    <div class="object-block-opportunity" :class="objectBlockClasses">
        <div class="object-block__main">
            <div class="object-block__header">
                <div class="object-block__header-title-container">
                    <CompassObject object="opportunity" size="small" />
                    <div>
                        <div class="object-block__header-name-container">
                            <BlockName :name="data.name" :link="linkCard" />
                            <TagStatus
                                v-if="status && data.status"
                                :id="data.status?.id ?? data.status"
                                :label="status.label"
                                size="small"
                            />
                        </div>
                        <div
                            v-if="!!opportunityAmount"
                            class="typographies-paragraph-small-regular object-block__header-caption"
                        >
                            {{
                                $filters.numberFormatWithOptions(
                                    opportunityAmount,
                                    { precision: numformat.precision },
                                    true,
                                )
                            }}
                        </div>
                    </div>
                </div>
                <CompassIconButton
                    v-if="variant === OBJECT_BLOCK_VARIANT.LINKED"
                    icon="close"
                    @click="$emit('unlink')"
                />
            </div>
            <BlockDescriptionListPart
                v-if="displayDescriptionList && hasDescriptionListItem"
                v-bind="$props"
                :showCompany="displayCompanyDescriptionItem"
                :showContact="displayContactDescriptionItem"
            />
        </div>
        <div v-if="$slots.company && $slots.contact" class="object-block__related-container">
            <slot v-if="variant === OBJECT_BLOCK_VARIANT.OVERVIEW" name="company" />
            <slot v-if="variant === OBJECT_BLOCK_VARIANT.OVERVIEW" name="contact" />
        </div>
    </div>
</template>

<script>
import BlockGeneric from 'vcomponents/common/object/BlockGeneric.vue';
import BlockDescriptionListPart from 'vcomponents/common/object/BlockDescriptionListPart.vue';
import TagStatus from 'vcomponents/common/TagStatus/TagStatus.vue';
import { OBJECT_BLOCK_VARIANT } from 'Dictionaries/commonComponents/ObjectBlockEnums';

import OpportunitiesStatus from 'Config/authenticated/OpportunitiesStatus';
import { createNamespacedHelpers } from 'vuex';
const { mapState: corpState } = createNamespacedHelpers('corp');

export default {
    components: { TagStatus, BlockDescriptionListPart },
    extends: BlockGeneric,
    props: {
        variant: {
            type: String,
            default: OBJECT_BLOCK_VARIANT.PREVIEW,
            validator(value) {
                return [
                    OBJECT_BLOCK_VARIANT.PREVIEW,
                    OBJECT_BLOCK_VARIANT.OVERVIEW,
                    OBJECT_BLOCK_VARIANT.LINKED,
                ].includes(value);
            },
        },
        showCompany: {
            type: Boolean,
            default: true,
        },
        showContact: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['unlink'],
    computed: {
        ...corpState(['numformat']),
        displayCompanyDescriptionItem() {
            return this.showCompany && !!this.data.company && !this.hasSlotCompany;
        },
        displayContactDescriptionItem() {
            return this.showContact && !!this.data.contact && !this.hasSlotContact;
        },
        hasDescriptionListItem() {
            return this.displayCompanyDescriptionItem || this.displayContactDescriptionItem;
        },
        status() {
            if (!this.data.status) {
                return null;
            }
            if (this.data.status.label && this.data.status.color) {
                return this.data.status;
            }
            const opportunitiesStatus =
                OpportunitiesStatus[this.data.status?.id ?? this.data.status];

            if (!opportunitiesStatus) {
                return null;
            }

            return {
                color: opportunitiesStatus.chipColor,
                label: opportunitiesStatus.label,
            };
        },
        opportunityAmount() {
            if (!this.data.amount) {
                return null;
            }
            if (this.data.amount instanceof Object && this.data.amount.value) {
                return this.data.amount.value;
            }
            return this.data.amount;
        },
    },
    created() {
        if (this.data.company) {
            this.data.company.link = this.getLink({
                id: this.data.company.id,
                type: 'company',
                subtype: this.data.company.type,
            });
        }

        this.linkCard = this.getLink({
            id: this.getObjectId(),
            type: 'opportunity',
        });
    },
};
</script>

<style lang="scss" scoped>
.object-block-opportunity {
    .object-block-contact,
    .object-block-company {
        margin-top: var(--spacing-3);
    }
}
</style>
